import React, { useState } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { useDispatch, useSelector } from 'react-redux';
import { Text } from 'office-ui-fabric-react/lib/Text';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { search } from '../../actions/search';
import styles from './PartnerTypeAhead.style';
import ActionTypeaheadPicker from '../TypeaheadPicker/ActionTypeaheadPicker';

const PartnerTypeAhead = ({
  field: { name },
  form: { errors = {}, setFieldValue = () => {}, setFieldTouched = () => {} },
  label,
  required,
  initialValue,
}) => {
  const setFormValue = value => {
    setFieldValue(name, value);
    setFieldTouched(name);
  };

  const errorMessage = get(errors, name);

  const dispatch = useDispatch();
  const [selectedPartner, setSelectedPartner] = useState(initialValue);
  const suggestions = useSelector(state => get(state, 'search.results'));
  const [isLoading, setIsLoading] = useState(false);
  const searchSuggestions = get(suggestions, 'partners', [])
    .map(partner => ({
      key: partner.partnerAddress,
      text: partner.name,
    }))
    .slice(0, 5);
  const onTypeAction = async newInput => {
    if (!newInput) return;
    setIsLoading(true);
    await dispatch(search(['partners'], newInput));
    setIsLoading(false);
  };

  const onPartnerSelection = partner => {
    setSelectedPartner(partner);
    setFormValue(partner.key);
  };

  return (
    <Stack>
      {label && (
        <Stack horizontal verticalAlign="start">
          <Label data-testid="typeahead-label">{label}</Label>
          {required && <Text className={styles.asterisk}>*</Text>}
        </Stack>
      )}

      <ActionTypeaheadPicker
        options={searchSuggestions}
        selectedValue={selectedPartner}
        onChange={onPartnerSelection}
        onTypeAction={onTypeAction}
        isLoading={isLoading}
        placeholder="Select"
        aria-required={required}
      />

      {errorMessage && (
        <div role="alert">
          <p className={styles.errorMessage}>
            <span data-testid="typeahead-required" data-automation-id="error-message">
              {errorMessage}
            </span>
          </p>
        </div>
      )}
    </Stack>
  );
};

PartnerTypeAhead.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
  form: PropTypes.shape({
    errors: PropTypes.shape({}),
    setFieldTouched: PropTypes.func,
    setFieldValue: () => {},
  }).isRequired,
  label: PropTypes.string,
  required: PropTypes.bool,
  initialValue: PropTypes.object,
};

PartnerTypeAhead.defaultProps = {
  required: false,
  label: null,
  initialValue: null,
};

export default PartnerTypeAhead;
